import { Dispatch, SetStateAction } from "react";
import { Track } from "../../proto/api_pb";
import { TrackVersionsObj } from "../../pages/MyTracks/types";
export interface TrackVersionsProps {
  stopAllSongs: () => void;
  handlePlayPause: (id: string) => void;
  version: string;
  isPlaying: boolean;
  id: string;
  label: string;
  timeStamp: number;
  bpm: number | undefined;
  ownerId: string;
  isSelected: boolean;
  selectedVersionId: string | undefined;
  handleChange: (timeStamp: number) => Promise<void>;
  updateSelectedTrackVersion: () => void;
  handleOpenDeleteModal: (id: string) => void;
}
export interface TrackVersionGroupProps {
  id: string | undefined;
  selectedVersionId: string | undefined;
  handleChange: (timeStamp: number) => Promise<void>;
  isPlaying: boolean;
  handleStop: (id: string) => void;
  evokeCallBack: number;
}

export interface VersionComponentProps {
  track: Track;
}

export interface SelectVersionModalProps {
  isSelectVersionModalOpen: boolean;
  setIsSelectVersionModalOpen: Dispatch<SetStateAction<boolean>>;
  versions: TrackVersionsObj[] | undefined;
  setChangeVersionLoading: Dispatch<SetStateAction<boolean>>;
  handleChange: (timeStamp: number) => Promise<void>;
  selectedTrackVersionLabel: string | undefined;
}

export const month = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const defaultProfilePhoto =
  "https://png.pngtree.com/png-vector/20191110/ourmid/pngtree-avatar-icon-profile-icon-member-login-vector-isolated-png-image_1978396.jpg";

export const trackVersionsColumns = [
  "Label",
  "Play/Pause",
  "Date created",
  "Time",
  "Uploaded by",
  "Download",
  "Current version",
];
export interface selectedTrackObj {
  track: Track | undefined;
  waveSurfer?: WaveSurfer;
}
